import { LssProp } from '@lucidhq/lucidium';

import { Status } from '@/components';

export enum PanelStatusEnum {
  live = 'live',
  maintenance = 'maintenance',
}

export const PanelStatusMap = {
  [PanelStatusEnum.live]: 'Live',
  [PanelStatusEnum.maintenance]: 'Maintenance',
} as const;

const PanelStatusColorMap: Record<PanelStatusEnum, LssProp> = {
  [PanelStatusEnum.live]: { borderColor: 'success400', bg: 'success100' },
  [PanelStatusEnum.maintenance]: {
    borderColor: 'warning400',
    bg: 'warning100',
  },
};

export type PanelStatusType = keyof typeof PanelStatusMap;

export interface PanelStatusProps {
  status: PanelStatusType;
}

export const PanelStatus = ({ status }: PanelStatusProps) => (
  <Status
    status={status}
    colorMap={PanelStatusColorMap}
    statusMap={PanelStatusMap}
    width="100px"
  />
);
